import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames/bind';
import { useSpring, animated, easings } from '@react-spring/web';
import { getCssColorFromColorName } from '../../../utils/colors';
import { ColorNames } from '../../../constants/colorVars';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const SCALE_MIN = 0.05;
const SCALE_MAX = 1;
const OPACITY_MIN = 0;
const OPACITY_MAX = 0.5;
const DURATION_FADE_IN_MS = 1000;
const DURATION_FADE_OUT_MS = 800;
const Pulser = ({ width = 100, color = ColorNames.Purple, elmId = 'pulser', className, }) => {
    const colorRaw = getCssColorFromColorName(color);
    const styles = useSpring({
        from: { scale: SCALE_MIN, opacity: OPACITY_MIN },
        to: async (next) => {
            while (true) {
                await next({
                    scale: SCALE_MAX * 0.7,
                    opacity: OPACITY_MAX,
                    config: {
                        duration: DURATION_FADE_IN_MS,
                        easing: easings.easeOutCubic,
                    },
                });
                await next({
                    scale: SCALE_MAX,
                    opacity: OPACITY_MIN,
                    config: {
                        duration: DURATION_FADE_OUT_MS,
                        easing: easings.easeOutQuad,
                    },
                });
                await next({ scale: SCALE_MIN, opacity: OPACITY_MIN, immediate: true });
            }
        },
    });
    const sizeStyle = width
        ? { width, height: width }
        : { width: '100%', height: '100%' };
    return (_jsx(animated.div, { "data-elm-id": elmId, style: {
            ...styles,
            backgroundColor: colorRaw,
            ...sizeStyle,
        }, className: cx('pulser', className) }));
};
export default Pulser;
//# sourceMappingURL=index.js.map